import { render, staticRenderFns } from "./ErrorBoundary.vue?vue&type=template&id=5df62152&"
import script from "./ErrorBoundary.vue?vue&type=script&lang=js&"
export * from "./ErrorBoundary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5df62152')) {
      api.createRecord('5df62152', component.options)
    } else {
      api.reload('5df62152', component.options)
    }
    module.hot.accept("./ErrorBoundary.vue?vue&type=template&id=5df62152&", function () {
      api.rerender('5df62152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ErrorBoundary.vue"
export default component.exports